import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Layout from "components/yenimahalle/Layout";
import BasicHeader from "components/yenimahalle/BasicHeader";
import ListGrid from "components/yenimahalle/ListGrid";
import PortalApi from "api/PortalApi";
import { GetMaliYonetimResponse, MaliYonetimListesi } from "models/Response/Portal";
import tw from "twin.macro";
import styled from "styled-components";

const ContentContainer = tw.div`
  pt-8 pb-16 px-4
  flex flex-col lg:flex-row
  justify-between items-start
  max-w-screen-xl mx-auto
`;

const LeftColumn = tw.div`w-full lg:w-9/12 px-5`;
const RightColumn = tw.div`w-full lg:w-3/12 mt-8 lg:mt-0`;

const SidebarHeading = tw.h3`
  inline-block my-4 pl-3 py-1 text-xl font-bold border-l-4 border-primary-500
`;

const NavCard = styled.button`
  ${tw`
    block w-full text-left mb-3 py-3 px-4
    border border-gray-200 rounded-lg
    hover:bg-primary-100
    focus:outline-none
  `}
`;

export default function MaliYonetim() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const [items, setItems] = useState<MaliYonetimListesi[]>([]);

  useEffect(() => {
    const fetchData = async () => {
      if (!id) return;
      const res = await PortalApi.getMaliYonetim(Number(id));
      if (res && res.content?.maliYonetimListesi) {
        setItems(res.content.maliYonetimListesi);
      }
    };
    fetchData();
  }, [id]);

  const handleDownload = (url: string) => {
    window.open(url, "_blank");
  };

  const navLinks = [
    { title: "Stratejik Plan", path: "/MaliYonetim/StratejikPlan/1" },
    { title: "Faaliyet Raporları", path: "/MaliYonetim/FaaliyetRaporlari/2" },
    { title: "Performans Programı", path: "/MaliYonetim/PerformansProgrami/3" },
  ];

  return (
    <Layout>
      <BasicHeader
        headingLine1=""
        headingLine2="Sosyal Belediyecilik Anlayışına Sahip Mutlu Bir İlçe"
      />

      <ContentContainer>
        {/* Sol Kolon: API'den gelen listeyi ListGrid ile */}
        <LeftColumn>
          <ListGrid
            items={items.map(i => ({ title: i.header, url: i.url }))}
            onItemClick={item => handleDownload(item.url)}
            onFilterChange={undefined}
          />
        </LeftColumn>

        {/* Sağ Kolon: Sabit navigasyon */}
        <RightColumn>
          <SidebarHeading>Mali Yönetim</SidebarHeading>
          {navLinks.map(link => (
            <NavCard key={link.path} onClick={() => navigate(link.path)}>
              {link.title}
            </NavCard>
          ))}
        </RightColumn>
      </ContentContainer>
    </Layout>
  );
}
